import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconExternalLink, Modal } from '@veneer/core';
import { useI18n } from '@jarvis/react-portal-addons';

import {
  ButtonContainer, Content, Description, ModalButton,
} from './styles';

const TouModal = ({
  show, onAccept, onExit, touUrl,
}) => {
  const { t } = useI18n();
  const [isTabNavigation, setIsTabNavigation] = useState(false);

  useEffect(() => {
    if (show) {
      setIsTabNavigation(false);
    }
  }, [show]);

  const handleKeyDown = useCallback(event => {
    if (event.key === 'Tab') {
      setIsTabNavigation(true);
    }
  }, []);

  const handlePointerInteraction = useCallback(() => {
    setIsTabNavigation(false);
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <Modal
        customStyle={{ padding: '32px !important' }}
        align="start"
        closeOnBlur={false}
        data-testid="tou-modal"
        id="tou-modal"
        onKeyDown={handleKeyDown}
        onMouseDown={handlePointerInteraction}
        onClose={onExit}
        onTouchStart={handlePointerInteraction}
        show={show}
        title={(
          <span data-testid="tou-modal-title">
            {t('tou.modal.newUser.title')}
          </span>
        )}
      >
        <Content>
          <Description
            $isTabNavigation={isTabNavigation}
            text={t('tou.modal.newUser.description')}
            tagReplaceStart={`<a href="${touUrl}" target="_blank" rel="noopener noreferrer" data-testid="tou-modal-description-link">`}
            tagReplaceEnd="</a>"
            data-testid="tou-modal-description"
            icon={(
              <IconExternalLink
                color="electricBlue7"
                size={20}
                data-testid="tou-modal-icon"
              />
            )}
          />
        </Content>
        <ButtonContainer data-testid="tou-modal-button-container">
          <ModalButton
            data-testid="tou-modal-button-exit"
            appearance="secondary"
            colorScheme="neutral"
            onClick={onExit}
          >
            {t('tou.modal.exit')}
          </ModalButton>
          <ModalButton
            data-testid="tou-modal-button-continue"
            appearance="secondary"
            colorScheme="neutral"
            onClick={onAccept}
          >
            {t('tou.modal.continue')}
          </ModalButton>
        </ButtonContainer>
      </Modal>
    </div>
  );
};

TouModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired,
  touUrl: PropTypes.string.isRequired,
};

export default TouModal;
